import { useSelector } from "react-redux";

/**
 * @typedef {Object} UserAddress
 * @property {string} address1
 * @property {string} address2
 * @property {string} city
 * @property {string} state
 * @property {string} postcode
 * @property {string} countryId
 * @property {number} lat
 * @property {number} lng
 * @property {any} savedLocation
 * 
 * @returns {UserAddress}
 */
export default function useUserAddress() {
  const userAddress = useSelector(state => state.user.userAddress)

  return userAddress
}